<template>
  <div>
    <page-header>
      <template #breadcrumbs> Шаблоны маршрутов </template>
      <h2>Шаблоны маршрутов</h2>
      <template #actions>
        <div class="actions">
          <button-component v-if="canEdit" @click="editCard(0)">
            Создать
          </button-component>
          <button-component
            kind="tertiary"
            :class="{ filtered: isFiltered }"
            @click="modals.filter = !modals.filter"
          >
            <template #prepend>
              <icon-component class="mr-2" name="filter" />
            </template>
            Фильтр
          </button-component>
        </div>
      </template>
    </page-header>

    <section class="content">
      <template v-if="page.items">
        <template v-if="page.items.length">
          <div class="table-inner">
            <table class="table-custom">
              <thead>
                <tr>
                  <th width="50px"></th>
                  <th width="5%" class="text-center">ID</th>
                  <th>Название</th>
                  <th width="5%">Активный</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in page.items"
                  :key="item.id"
                  v-on:dblclick="editCard(item.id)"
                >
                  <td>
                    <menu-component class="actions" :actions="actions(item)" />
                  </td>
                  <td class="text-center">{{ item.id }}</td>
                  <td>{{ item.name }}</td>
                  <td>
                    <Checkbox
                      :id="'isActive_' + item.id"
                      class="text-center"
                      v-bind:modelValue="item.isActive"
                      :disabled="true"
                    />
                    <!--                  <input type="checkbox" v-model="item.isActive" :disabled="true"/>-->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-if="page.pagesTotal > 1">
            <Pagination
              :page-count="page.pagesTotal"
              :current-page="page.pageNumber"
              @change="onPageChange($event)"
            />
          </div>
          <div>
            <PageCounter
              :isFiltered="isFiltered"
              :totalCount="totalCount"
              :filteredCount="page.itemsTotal"
            />
          </div>
        </template>
        <template v-else>
          <EmptyListMessage />
        </template>
      </template>

      <section class="modals">
        <transition name="filter">
          <div class="filter" v-if="modals.filter">
            <RoutesFilters
              v-bind:filters="filters"
              v-on:apply="onFiltersApply($event)"
              v-on:reset="onFiltersReset($event)"
            />
          </div>
        </transition>
      </section>
    </section>
  </div>
</template>

<script>
import API from "../api/routes";
import RoutesFilters from "../components/RoutesFilters";
import ButtonComponent from "@/common/ui/ButtonComponent";
import PageHeader from "@/common/components/page/PageHeader";
import IconComponent from "@/common/ui/IconComponent";
import EmptyListMessage from "../../../common/components/EmptyListMessage";
import Constants from "../../../common/constants";
import Checkbox from "@/common/ui/checkbox";
import security from "../../../common/mixins/security";
import MenuComponent from "@/common/ui/components/page/MenuComponent";
import filtermanager from "../../../common/mixins/filtermanager";
import PageCounter from "@/common/components/PageCounter";

export default {
  name: "Routes",
  components: {
    MenuComponent,
    Checkbox,
    EmptyListMessage,
    RoutesFilters,
    IconComponent,
    PageHeader,
    ButtonComponent,
    PageCounter,
  },
  mixins: [security, filtermanager],
  created() {
    this.checkPermission(Constants.RouteEdit).then((response) => {
      this.canEdit = response.data;
    });
    this.getTotalCount();
    this.loadPage();
  },
  data() {
    return {
      request: {
        pageNumber: 1,
        pageSize: Constants.pageSize,
      },
      filters: {
        name: "",
        isActive: null,
      },
      page: {},
      modals: {
        filter: false,
      },
      canEdit: true,
      isFiltered: false,
      totalCount: 0,
    };
  },
  methods: {
    getTotalCount() {
      const self = this;
      API.search({ pageNumber: 1, pageSize: 1 }).then((response) => {
        self.totalCount = response.data.itemsTotal;
      });
    },
    actions(item) {
      let result = [
        {
          title: "Просмотр",
          icon: "eye",
          click: () => this.viewCard(item.id),
        },
      ];
      if (this.canEdit) {
        result = result.concat([
          {
            title: "Редактировать",
            icon: "pen",
            click: () => this.editCard(item.id),
          },
          {
            title: "Удалить",
            icon: "trash",
            click: () => this.deleteCard(item.id),
          },
        ]);
      }
      return result;
    },
    onPageChange(pageNumber) {
      this.request.pageNumber = pageNumber;
      this.loadPage();
    },
    loadPage() {
      const filter = this.loadFilter();
      if (filter) {
        this.filters = filter;
        this.isFiltered = true;
      }
      const params = Object.assign(this.filters, this.request);
      API.search(params).then((response) => {
        this.page = response.data;
      });
    },
    viewCard(id) {
      this.$router.push({
        name: "routeCard",
        params: { action: "view", id: id },
      });
    },
    editCard(id) {
      if (this.canEdit) {
        this.$router.push({
          name: "routeCard",
          params: { action: "edit", id: id },
        });
      } else {
        this.viewCard(id);
      }
    },
    deleteCard(id) {
      Constants.alert.fire(Constants.confirmOptions.delete).then((res) => {
        if (res.isConfirmed) {
          API.delete(id).then((response) => {
            Constants.alert.fire(
              "Удаление",
              response.data.message,
              response.data.success ? "success" : "error"
            );
            this.getTotalCount();
            this.loadPage();
          });
        }
      });
    },
    onFiltersApply(filters) {
      this.filters = filters;
      this.request.pageNumber = 1;
      this.modals.filter = false;
      this.saveFilter(this.filters);
      this.isFiltered = true;
      this.loadPage();
    },
    onFiltersReset(filters) {
      this.filters = filters || {};
      this.request.pageNumber = 1;
      this.modals.filter = false;
      this.removeFilter();
      this.isFiltered = false;
      this.loadPage();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "/src/assets/theme/default/colors.scss";

.content {
  padding: 16px 16px 0 16px;
  position: relative;
  overflow-y: visible;
  .filter {
    position: absolute;
    width: 350px;
    height: auto;
    top: 0;
    right: 0;
    overflow: hidden;
    background-color: transparent;
    opacity: 1;
    transition: opacity 0.2s;
  }
  .filter-enter, .filter-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
}
.filtered {
  color: $red;
  &:hover {
    color: $red-dark;
  }
}
</style>
